import Cookies from 'js-cookie'
var isFunction = function(val){
	return Object.prototype.toString.call(val) === '[object Function]';
}

let _gWinInfo = null
const getWinInfo = () => {
  if (!_gWinInfo) {
    _gWinInfo = {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }

  return _gWinInfo
}

const queryDom = selector => {
  return document.querySelector(selector)
}

const queryDoms = selectors => {
  return document.querySelectorAll(selectors)
}

const getUserId = () => {
  return Cookies.get('UserID')
}

const getUrlParam = (queryName, url = '') => {
    url = url || window.location.href || ''
    url = url.split('?')[1] || ''
    var reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i')
    var r = url.match(reg)
    if (r != null) {
        return decodeURI(r[2])
    } else {
        return null
    }
}

var isNumber = function(val){
	return Object.prototype.toString.call(val) === '[object Number]';
}

/**
 * @功能 按格式转换日期 yyyy-MM-dd h:m:s
 * @参数 <Date> date
 * @参数 <String> fmt
 * @use dateFormat(new Date(), 'yyyy-MM-dd h:m:s');
 * 		dateFormat(new Date(), 'yyyy年MM月dd日 h:m:s');
 */
var dateFormat = function (date, fmt) {
	var o = {
		'M+': date.getMonth() + 1, 	// 月
		'd+': date.getDate(), 		// 日 
		'h+': date.getHours(), 		// 时 
		'm+': date.getMinutes(), 	// 分 
		's+': date.getSeconds(), 	// 秒 
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度 
		'S': date.getMilliseconds() // 毫秒 
	};
	
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	
	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
		}
	}

	return fmt;
}

export { isFunction, getWinInfo, queryDom, queryDoms, getUserId, getUrlParam, isNumber, dateFormat }



// WEBPACK FOOTER //
// ./src/common/utils/utils.js